import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { checkApiStatus } from './utils/renderRoutes';
import MainLayout from './layouts/MainLayout';
import Checkout from './pages/checkout/Checkout';
import SecuredInvoice from './pages/payment-methods/securedInvoice';
import SecuredInstallment from './pages/payment-methods/securedInstallment';
import SecuredDirectDebit from './pages/payment-methods/securedDirectDebit';
import NotFound from './pages/NotFound';
import UUIDContexted from './UUIDContexted';
import Paypal from './pages/payment-methods/Paypal';
import CreditCardPage from './pages/payment-methods/creditCard/CreditCardPage';
import Wero from './pages/payment-methods/Wero';
import GooglePayPage from './pages/payment-methods/googlePay/GooglePayPage';


const App: React.FC = () => {
  const [pblResponseData, setPblResponseData] = useState<any>();

  return (
      <div className="App flex-wrapper">
        <Routes>
          <Route path="/:uuid/*" element={
            <UUIDContexted pblResponseDataState={{ pblResponseData, setPblResponseData }}>
              <MainLayout>
                <Routes>
                    <Route index path="/" element={<Checkout />} />
                    <Route path="/invoice" element={<SecuredInvoice />} />
                    <Route path="/installment" element={<SecuredInstallment />} />
                    <Route path="/debit" element={<SecuredDirectDebit />} />
                    <Route path="/paypal" element={<Paypal />} />
                    <Route path="/wero" element={<Wero />} />
                    <Route path="/creditCard" element={<CreditCardPage />} />
                    <Route path="/googlePay" element={<GooglePayPage />} />
                    <Route path="/success" element={checkApiStatus(pblResponseData)} />
                    <Route path="/error" element={checkApiStatus(pblResponseData)} />
                    <Route path="/status" element={checkApiStatus(pblResponseData)}  />
                    <Route path="*" element={<NotFound />} />

                </Routes>
              </MainLayout>
            </UUIDContexted>
            } 
          />
          <Route path="*" element={
            <MainLayout>
              <Routes>
                <Route path="/" element={<NotFound />} />
              </Routes>
            </MainLayout>
            }
          />
        </Routes>        
      </div>
  );
}

export default React.memo(App);
